export const CHECKOUT_URL = 'https://golf-instructor-ready.impultienda.ar/checkout'

export const CTA_LABEL = 'GET THE COMPLETE 6-IN-1 TEACHING SYSTEM NOW'

export const HERO_CTA_LABEL = 'GET THE COMPLETE TEACHING LIBRARY NOW'

export function trackCheckout() {
  if (typeof window !== 'undefined' && (window as unknown as { fbq?: unknown }).fbq) {
    ;(window as unknown as { fbq: (...args: unknown[]) => void }).fbq('track', 'InitiateCheckout', {
      content_name: 'Golf Instructor Ready — Complete 6-in-1 Teaching System',
      value: 27,
      currency: 'USD',
    })
  }
}
